// extracted by mini-css-extract-plugin
export var container = "_7q-0";
export var error = "_7q-9";
export var label = "_7q-5";
export var light = "_7q-6";
export var md = "_7q-3";
export var sm = "_7q-2";
export var thin = "_7q-8";
export var thinBold = "_7q-7";
export var vertical = "_7q-4";
export var xs = "_7q-1";